"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastAnonymousProfileId = void 0;
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const Utils_1 = require("../helpers/Utils");
const Auth_1 = require("../helpers/Auth");
const cookies = new universal_cookie_1.default();
const LAST_ANON_PID_COOKIE = 'lastAnonymousProfileId';
const getLastAnonymousProfileId = () => {
    let uuid = cookies.get(LAST_ANON_PID_COOKIE);
    if (!uuid) {
        if (crypto && crypto.randomUUID) {
            uuid = crypto.randomUUID();
        }
        else {
            uuid = (0, Utils_1.generateUUID)();
        }
        const cookieDomain = (0, Auth_1.getCookieDomain)();
        cookies.set(LAST_ANON_PID_COOKIE, uuid, { path: '/', domain: cookieDomain });
    }
    return uuid;
};
exports.getLastAnonymousProfileId = getLastAnonymousProfileId;
//# sourceMappingURL=User.js.map